import { render, staticRenderFns } from "./DishCategoriesList.vue?vue&type=template&id=44dcfa47&scoped=true&"
import script from "./DishCategoriesList.vue?vue&type=script&lang=js&"
export * from "./DishCategoriesList.vue?vue&type=script&lang=js&"
import style0 from "./DishCategoriesList.vue?vue&type=style&index=0&id=44dcfa47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dcfa47",
  null
  
)

component.options.__file = "DishCategoriesList.vue"
export default component.exports